import { Card, Button, theme } from "antd";
import { useSortable } from "@dnd-kit/sortable";
import { DragOutlined } from "@ant-design/icons";
import { CSSProperties } from "react";
import { Question } from "../../../../hooks/api/survey";
import { QuestionPreview } from "../QuestionPreview";

interface Props {
  question: Question;
  active: boolean;
  onSelect: () => void;
  onDelete: () => void;
}

export function SortableQuestionItem({
  question,
  active,
  onSelect,
  onDelete,
}: Props) {
  const { token } = theme.useToken();
  const {
    setNodeRef,
    listeners,
    attributes,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: question.id });

  const style: CSSProperties = {
    transform: transform
      ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
      : undefined,
    transition,
    opacity: isDragging ? 0.5 : 1,
    cursor: "grab",
  };

  return (
    <div ref={setNodeRef} style={style}>
      <Card
        onClick={onSelect}
        style={{
          border: active ? `1px solid ${token.colorPrimary}` : undefined,
        }}
        extra={
          <Button danger size="small" onClick={onDelete}>
            Delete
          </Button>
        }
        title={
          <span
            {...listeners}
            {...attributes}
            onClick={(e) => e.stopPropagation()}
            style={{ cursor: "grab" }}
          >
            <DragOutlined /> {question.title || "Untitled"}
            {question.required && (
              <span style={{ color: "red", marginLeft: 4 }} title="Required">
                *
              </span>
            )}
          </span>
        }
      >
        <QuestionPreview question={question} />
      </Card>
    </div>
  );
}
